import React from 'react';
import SelectionStatus from 'portfolio/components/SelectionStatus';
import WidgetToolbar from 'widgets/WidgetToolbar/WidgetToolbar';
import { useWidgetPortfolioSelectionStatus } from 'widgets/hooks';
import ZoomButtons from 'utils/components/Zoom/ZoomButtons';
import { PortfolioPlSettings } from 'widgets/portfolioPl/PortfolioPlSettings';
import { PortfolioPlAggregationType } from 'widgets/portfolioPl/store/config/PortfolioPlWidgetConfigState';
import { usePortfolioPlConfigSlice } from 'widgets/portfolioPl/store/config/configSlice';

import './PortfolioPlToolbar.scss';
import WidgetToolbarShowHidePanel from 'widgets/WidgetToolbarShowHidePanel/WidgetToolbarShowHidePanel';
import { Dropdown } from '@instinet-analytics/semantic-ui-components';
import { DropdownItemProps } from '@instinet-analytics/semantic-ui-components';

interface PortfolioPlToolbarProps {
    width: number;
}

export default function PortfolioPlToolbar(props: PortfolioPlToolbarProps) {
    const { width } = props;

    const { config, dispatchConfigChanged } = usePortfolioPlConfigSlice();
    const { aggregationType } = config;

    const { hasValidSelection, portfolioSelectionRequirements } =
        useWidgetPortfolioSelectionStatus();

    const onAggregationTypeChanged = (
        aggregationType: PortfolioPlAggregationType
    ) => {
        dispatchConfigChanged({ aggregationType });
    };

    return (
        <WidgetToolbarShowHidePanel mustShow={!hasValidSelection}>
            <div
                className="PortfolioPlToolbar panel-header"
                style={{
                    width: width + 'px',
                }}
            >
                {hasValidSelection ? (
                    <div className="toolbar aggregation-type-dropdown">
                        <div className="label">Type:</div>
                        <AggregationTypeDropdown
                            value={aggregationType}
                            onChanged={onAggregationTypeChanged}
                        />
                    </div>
                ) : (
                    <div className="toolbar">
                        <SelectionStatus
                            selectionRequirements={
                                portfolioSelectionRequirements
                            }
                            widgetName="Profit & Loss Widget"
                        />
                    </div>
                )}
                <WidgetToolbar
                    fixedItems={hasValidSelection ? <ZoomButtons /> : undefined}
                    settingsHeader="Profit & Loss Settings"
                    settingsBody={<PortfolioPlSettings />}
                    showEditLayout={hasValidSelection}
                />
            </div>
        </WidgetToolbarShowHidePanel>
    );
}

function AggregationTypeDropdown(props: {
    value: PortfolioPlAggregationType;
    onChanged: (aggregationType: PortfolioPlAggregationType) => void;
}) {
    const { value, onChanged } = props;

    interface AggregationTypeDropdownItem {
        text: string;
        value: PortfolioPlAggregationType;
    }
    const combined: AggregationTypeDropdownItem = {
        text: 'Combined',
        value: 'combined',
    };
    const buys: AggregationTypeDropdownItem = {
        text: 'Buys',
        value: 'buys',
    };
    const sells: AggregationTypeDropdownItem = {
        text: 'Sells',
        value: 'sells',
    };

    const dropdownValues: DropdownItemProps[] = [combined, buys, sells];

    return (
        <Dropdown
            className="AggregationTypeDropdown"
            options={dropdownValues}
            value={value}
            onChange={onChanged}
            inlineToolbar
        />
    );
}
